import Launguage from '../helpers/Launguage';

export default class ProjectRenderer {
  constructor() {
    this.DATA = {
      2016: {
        maizuru: {
          kyotoResearch: {
            title: {
              jp: '京都:Re-Search 2016 in 舞鶴',
              en: 'Kyoto: Re-Search 2016<br> in Maizuru'
            },
            hover_title: {
              jp: 'レポートを見る',
              en: 'See report'
            },
            link: '/maizuru'
          }
        }
      },
      2017: {
        kyotanabe: {
          kyotoResearch: {
            title: {
              jp: '京都:Re-Search 2017 in 京田辺',
              en: 'Kyoto: Re-Search 2017<br> in Kyotanabe'
            },
            hover_title: {
              jp: 'レポートを見る',
              en: 'See report'
            },
            link: '/kyotanabe'
          }
        },
        fukuchiyama: {
          kyotoResearch: {
            title: {
              jp: '京都:Re-Search 2017 in 福知山',
              en: 'Kyoto: Re-Search 2017<br> in Fukuchiyama'
            },
            hover_title: {
              jp: 'レポートを見る',
              en: 'See report'
            },
            link: '/fukuchiyama'
          }
        },
        maizuru: {
          kyotoResearch: {
            title: {
              jp: '京都:Re-Search 2016 in 舞鶴',
              en: 'Kyoto: Re-Search 2016<br> in Maizuru'
            },
            hover_title: {
              jp: 'レポートを見る',
              en: 'See report'
            },
            link: '/maizuru'
          },
          daiKyoto: {
            title: {
              jp: '大京都 2017 in 舞鶴',
              en: 'Great Kyoto 2017<br> in Maizuru'
            },
            hover_title: {
              jp: 'レポートを見る',
              en: 'See report'
            },
            link: '/maizuru2017'
          }
        }
      },
      2018: {
        kameoka: {
          kyotoResearch: {
            title: {
              jp: '京都:Re-Search 2018 in 亀岡',
              en: 'Kyoto: Re-Search 2018<br> in Kameoka'
            },
            hover_title: {
              jp: 'レポートを見る',
              en: 'See report'
            },
            link: '/kameoka2018'
          }
        },
        kyotango: {
          kyotoResearch: {
            title: {
              jp: '京都:Re-Search 2018 in 京丹後',
              en: 'Kyoto: Re-Search 2018<br> in Kyotango'
            },
            hover_title: {
              jp: 'レポートを見る',
              en: 'See report'
            },
            link: '/kyotango2018'
          }
        },
        kyotanabe: {
          kyotoResearch: {
            title: {
              jp: '京都:Re-Search 2017 in 京田辺',
              en: 'Kyoto: Re-Search 2017<br> in Kyotanabe'
            },
            hover_title: {
              jp: 'レポートを見る',
              en: 'See report'
            },
            link: '/kyotanabe'
          },
          daiKyoto: {
            title: {
              jp: '大京都 2018 in 京田辺',
              en: 'Great Kyoto 2018<br> in Kyotanabe'
            },
            hover_title: {
              jp: 'レポートを見る',
              en: 'See report'
            },
            link: '/daikyoto-kyotanabe2018'
          }
        },
        fukuchiyama: {
          kyotoResearch: {
            title: {
              jp: '京都:Re-Search 2017 in 福知山',
              en: 'Kyoto: Re-Search 2017<br> in Fukuchiyama'
            },
            hover_title: {
              jp: 'レポートを見る',
              en: 'See report'
            },
            link: '/fukuchiyama'
          },
          daiKyoto: {
            title: {
              jp: '大京都 2018 in 福知山',
              en: 'Great Kyoto 2018<br> in Fukuchiyama'
            },
            hover_title: {
              jp: 'レポートを見る',
              en: 'See report'
            },
            link: '/daikyoto-fukuchiyama2018'
          }
        }
      },
      2019: {
        wazuka: {
          kyotoResearch: {
            title: {
              jp: "京都:Re-Search 2019 in 和束",
              en: "Kyoto: Re-Search 2019<br> in wazuka"
            },
            hover_title: {
              jp: "レポートを見る",
              en: "See report"
            },
            link: "/wazuka2019"
          }
        },
        kameoka: {
          kyotoResearch: {
            title: {
              jp: "京都:Re-Search 2018 in 亀岡",
              en: "Kyoto: Re-Search 2018<br> in Kameoka"
            },
            hover_title: {
              jp: "レポートを見る",
              en: "See report"
            },
            link: "/kameoka2018"
          },
          daiKyoto: {
            title: {
              jp: "大京都 2019 in 亀岡",
              en: "Great Kyoto 2019<br> in Kameoka"
            },
            hover_title: {
              jp: "開催概要を見る",
              en: "See report"
            },
            link: "/daikyoto-kameoka2019"
          }
        },
        kyotango: {
          kyotoResearch: {
            title: {
              jp: "京都:Re-Search 2018 in 京丹後",
              en: "Kyoto: Re-Search 2018<br> in Kyotango"
            },
            hover_title: {
              jp: "レポートを見る",
              en: "See report"
            },
            link: "/kyotango2018"
          },
          daiKyoto: {
            title: {
              jp: "大京都 2019 in 京丹後",
              en: "Great Kyoto 2019<br> in Kyotango"
            },
            hover_title: {
              jp: "レポートを見る",
              en: "See report"
            },
            link: "/daikyoto-kyotango2019"
          }
        },
      },
      2020:{
              yawata: {
                kyotoResearch: {
                  title: {
                    jp: "京都:Re-Search 2020 in 八幡",
                    en: "Kyoto: Re-Search 2020<br> in yawata"
                  },
                  hover_title: {
                    jp: "レポートを見る",
                    en: "See report"
                  },
                  link: "/yawata2020"
                }
              },
              nantan: {
                kyotoResearch: {
                  title: {
                    jp: "京都:Re-Search 2020 in 南丹",
                    en: "Kyoto: Re-Search 2020<br> in nantan"
                  },
                  hover_title: {
                    jp: "レポートを見る",
                    en: "See report"
                  },
                  link: "/nantan2020"
                }
              },
              wazuka: {
                kyotoResearch: {
                  title: {
                    jp: "京都:Re-Search 2019 in 和束",
                    en: "Kyoto: Re-Search 2019<br> in wazuka"
                  },
                  hover_title: {
                    jp: "レポートを見る",
                    en: "See report"
                  },
                  link: "/wazuka2019"
                },
                daiKyoto: {
                  title: {
                    jp: "大京都 2020 in 和束",
                    en: "Great Kyoto 2020<br> in Wazuka"
                  },
                  hover_title: {
                    jp: "開催概要を見る",
                    en: "See report"
                  },
                  link: "/daikyoto-wazuka2020"
                }
              },
              kyotango: {
                kyotoResearch: {
                  title: {
                    jp: "京都:Re-Search 2018 in 京丹後",
                    en: "Kyoto: Re-Search 2018<br> in Kyotango"
                  },
                  hover_title: {
                    jp: "レポートを見る",
                    en: "See report"
                  },
                  link: "/kyotango2018"
                },
                ExtraDaiKyoto: {
                  title: {
                    jp: "大京都 2019 in 京丹後",
                    en: "Great Kyoto 2019<br> in Kyotango"
                  },
                  hover_title: {
                    jp: "レポートを見る",
                    en: "See report"
                  },
                  link: "/daikyoto-kyotango2019"
                }
              },
                daiKyoto: {
                  title: {
                    jp: "大京都 2020 in 京丹後",
                    en: "Great Kyoto 2020<br> in Kyotango"
                  },
                  hover_title: {
                    jp: "開催概要を見る",
                    en: "See report"
                  },
                  link: "/daikyoto-kyotango2020"
                }
              },
            },

    this.DEFAULT_YEAR = 2020;

    this.CLASS_NAME = {
      yearActive: 'active',
      yearSelected: 'selected',
      isLongSVG: 'is-long',
      onlyResearch: 'is-only-research',
      heldDaiKyoto: 'is-held-daikyoto',
      year2019: '2019'
    };

    this.LANG = Launguage.isJp() ? 'jp' : 'en';

    this.$year = $('.sec-project .year-select .years li');
    this.$contents = $('.sec-project .wrapper > .contents');
    this.$projects = $('.sec-project .projects');
    this.$project = $('.sec-project .projects .project');

    this.$projectItems = {
      wazuka: $('.sec-project .project-wazuka'),
      kameoka: $('.sec-project .project-kameoka'),
      kyotango: $('.sec-project .project-kyotango'),
      kyotanabe: $('.sec-project .project-kyotanabe'),
      fukuchiyama: $('.sec-project .project-fukuchiyama'),
      maizuru: $('.sec-project .project-maizuru')
    };

    this._init();
    this.$projects.animate({opacity: 'show'}, {duration: 0});
    this._activateNavsYear();
    this.$year.filter(`[data-year="${this.DEFAULT_YEAR}"]`).addClass(this.CLASS_NAME.yearSelected);
    this._renderProjectInfo(this.DEFAULT_YEAR);
    this._addEvent();
  }

  /**
   * yearの選択状態を解除し、projectを全て非表示にする.
   * @private
   */
  _init() {
    this.$projects.animate({opacity: 'hide'}, {duration: 0});
    this.$year.removeClass(this.CLASS_NAME.yearSelected);
    this.$project.removeClass(`${this.CLASS_NAME.onlyResearch} ${this.CLASS_NAME.heldDaiKyoto} ${this.CLASS_NAME.isLongSVG}`);
  }

  /**
   * イベント登録.
   * @private
   */
  _addEvent() {
    this.$year.filter(`.${this.CLASS_NAME.yearActive}`).on('click', (e) => {
      this._init();

      $(e.target).addClass(this.CLASS_NAME.yearSelected);
      this._renderProjectInfo($(e.target).text());
      this.$projects.animate({opacity: 'show'}, {duration: 400});
    });
  }

  /**
   * year情報がnullでないyearのNavを選択可能にする.
   * @private
   */
  _activateNavsYear() {
    for (let yearKey in this.DATA) {
      if (this.DATA[yearKey] !== null) {
        this.$year.filter(`[data-year="${yearKey}"]`).addClass(this.CLASS_NAME.yearActive);
      }
    }
  }

  /**
   * yearの情報をもとにprojectをレンダリングする.
   * @param year
   * @private
   */
  _renderProjectInfo(year) {
    const yearData = this.DATA[year];

    for (let areaKey in yearData) {
      if (yearData.hasOwnProperty(areaKey)) {
        const areaData = yearData[areaKey];
        const $target = this.$projectItems[areaKey];
        var p = this.$projectItems['Kyotango'];

        const isHeldDaiKyoto = areaData.hasOwnProperty('daiKyoto');
        const targetClassName = isHeldDaiKyoto ? this.CLASS_NAME.heldDaiKyoto : this.CLASS_NAME.onlyResearch;

        const $kyotoReserch = isHeldDaiKyoto ? $target.find('.links li:last-child') : $target.find('.links li:first-child');

        $kyotoReserch.find('a').attr('href', areaData.kyotoResearch.link);
        $kyotoReserch.find('.text .default').html(areaData.kyotoResearch.title[this.LANG]);
        $kyotoReserch.find('.text .hover').html(areaData.kyotoResearch.hover_title[this.LANG]);

        // adding ExtraDaikyoto
        if (year != "2020") {
          p.find(".links li.ExtraDaikyoto").addClass("hide")
        } else {
          p.find(".links li.ExtraDaikyoto").removeClass("hide")
          var d = $target.find(".links li.ExtraDaikyoto")
          d.find("a").attr("href", yearData["kyotango"].ExtraDaikyoto.link), d.find(".text .default").html(yearData["kyotango"].ExtraDaikyoto.title[this.LANG]), d.find(".text .hover").html(yearData["kyotango"].ExtraDaikyoto.hover_title[this.LANG])
        }


        if (isHeldDaiKyoto) {
          const $daikyoto = $target.find('.links li:first-child');

          $daikyoto.find('a').attr('href', areaData.daiKyoto.link);
          $daikyoto.find('.text .default').html(areaData.daiKyoto.title[this.LANG]);
          $daikyoto.find('.text .hover').html(areaData.daiKyoto.hover_title[this.LANG]);
        }

        if (areaKey === 'kyotanabe' && !yearData.hasOwnProperty('kameoka')) {
          $target.addClass(this.CLASS_NAME.isLongSVG);
        }

        if (year == '2019') {
            $target.filter('.project-kyotango').find('.content').css({'top': '-70px','right': '-317px'});
            $target.filter('.project-kameoka').find('.content').css({'top': '-43px','right': '-317px'});
            $target.filter('.project-kameoka').find('.links li:first-child').find('a').removeAttr('href');

        }

        $target.addClass(targetClassName);
      }
    }
  }
}
